module.exports = __webpack_public_path__ + "static/dashboard-mac-d5dbbf9a1a5a338231ae0aa35dc5aa9d.png";